import axios from 'axios';
// config
import { HOST_API_KEY } from '../config-global';

// ----------------------------------------------------------------------

const axiosAPI = axios.create({ baseURL: HOST_API_KEY });

axiosAPI.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response ? error.response.status : null;
    console.log(error, status);
    if (status === 401) {
      const newToken = error.response?.data?.token;
      if (newToken) {
        localStorage.setItem('token', newToken);
        axiosAPI.defaults.headers.common['ar-access-token'] = newToken;
        error.config.headers['ar-access-token'] = newToken;
        // error.config.baseURL = undefined;
        return axiosAPI.request(error.config);
      }
      localStorage.removeItem('token');
      await axiosAPI.post('/auth/logout');
      window.location.href = '/login';
    }

    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  }
);

/*

const refreshAuthLogic = (failedRequest: any) => {
  console.log(failedRequest);
  const newToken = failedRequest.resolve.config.data.token;
  localStorage.setItem('token', newToken);
  axiosAPI.defaults.headers.common['ar-access-token'] = newToken;
  failedRequest.response.config.headers['ar-access-token'] = newToken;
  return Promise.resolve();
};

// Instantiate the interceptor
createAuthRefreshInterceptor(axiosAPI, refreshAuthLogic); */

export default axiosAPI;
